import ManagerTempl from './manager.pug';

export default {
  name: 'Manager',
  template: ManagerTempl(),
  delimiters: ['${', '}}'],
  props: {
    manager: {
      type: Object,
      required: true,
    },
  },
  computed: {
    image() {
      return `../../assets/images/${this.manager.icon}.png`;
    },
  },
};



// WEBPACK FOOTER //
// ./new-blocks/manager/manager.js